import React from 'react'
//Bibliotecas
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom';

//Componentes
import FlexContainer from '../../../components/common/FlexContainer'
import Button from '../../../components/common/Button'
import ProgressBar from './ProgressBar';

function OvaCard({ ova, progreso}) {
    //Navigate
    const navigate = useNavigate();

    return (
        <FlexContainer flexDirection='column' width='90%' padding='24px' margin='32px 0' borderRadius='20px' boxShadow='20px 20px 40px rgba(0, 0, 0, 0.25)'>
            <FlexContainer flexDirection='row'>
            <ImageWrapper>
                <Image src={ova.info.url}></Image>
            </ImageWrapper>
            <FlexContainer width='70%'>
                <Title>{ova.info.titulo}</Title>
                <Description>{ova.info.data}</Description>
                <Button onClick={() => navigate(`../ova/${ova._id}`)}>Ver más</Button>
            </FlexContainer>
            </FlexContainer>
            <ProgressBar width='70%' max='100' value={progreso}></ProgressBar>
        </FlexContainer>
    )
}

export default OvaCard

const ImageWrapper = styled.div`
    width:40%;
    display:flex;
    justify-content:center;
    align-items:center; 
    background-color: var(--color-gris-claro);
    padding:8px;
    border-radius:10px;
    margin-right:32px;
`;

const Image = styled.img`
   max-height:160px;
`;

const Title = styled.h3`
    
`;

const Description = styled.p`
    font-weight:300;
    padding:24px 0;
`;